import { ShapeCategory } from '@/types/shapeCategories';
import Length from '../../../../source/js/shared/models/Geometry/Length';
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';

export default class NullConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions(): Record<string, Length> {
		return {
			width: new Length( 0 ),
			length: new Length( 0 ),
		};
	}

	get_labels(): Record<string, string> {
		return {};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {};
	}

	get_category(): ShapeCategory {
		return '';
	}
}
